import saveAs from './saveAs';

const saveContentAs = (content, type, name) => {
  const blob = new Blob([content], { type });
  saveAs(blob, name);
};

export default saveContentAs;
